import { AlertType, ClientAlertID, IInteractionObject } from 'models/clientAlert';

export const fillInteractions = (clientAlertIds: ClientAlertID[], isRead: boolean): IInteractionObject[] => {
  return clientAlertIds.map((clientAlertId) => {
    const arr = clientAlertId.split('__');
    const alertType = arr[0] as AlertType;
    const id = arr[1];

    return { id, alertType, read: isRead };
  });
};

export const getDateSentFrom = (dateSentFrom?: string): string => {
  if (dateSentFrom) {
    return dateSentFrom;
  }

  const lastYear = new Date();

  lastYear.setFullYear(lastYear.getFullYear() - 1);
  lastYear.setHours(0, 0, 0, 0);

  return lastYear.toISOString();
};

export const getDateSentTo = (dateSentTo?: string): string => {
  if (dateSentTo) {
    return dateSentTo;
  }

  const today = new Date();

  today.setHours(23, 59, 59, 999);

  return today.toISOString();
};
